import './S_ClipLoader.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  size?: number;
  loading?: boolean;
  color?: string;
  caption?: string;
}

export const S_ClipLoader = observer((props: IProps): ReactElement => {
  const { size = 200, loading = true, caption, color } = props;
  return (
    <>
      {loading && (
        <div className='s-clip-loader-wrapper'>
          <svg
            viewBox='0 0 100 100'
            preserveAspectRatio='xMidYMid'
            className='s-clip-loader'
            css={{ width: size, height: size, color }}
          >
            <g>
              <circle
                strokeLinecap='round'
                fill='none'
                strokeDasharray='50.26548245743669 50.26548245743669'
                stroke='currentColor'
                strokeWidth='8'
                r='32'
                cy='50'
                cx='50'
              >
                <animateTransform
                  values='0 50 50;360 50 50'
                  keyTimes='0;1'
                  dur='1s'
                  repeatCount='indefinite'
                  type='rotate'
                  attributeName='transform'
                />
              </circle>
            </g>
          </svg>
          {caption && <div className='s-clip-loader-caption'>{caption}</div>}
        </div>
      )}
    </>
  );
});
